/**
 * Created by Yaroslav S. on 10/07/2024
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IAiKeys } from '../managing-api-keys.interface';

@Component({
  selector: 'curr-deepseek-section',
  templateUrl: './deepseek-section.component.html',
  styleUrls: ['./deepseek-section.component.scss']
})
export class DeepseekSectionComponent implements OnInit {

  @Input() apiKeys: IAiKeys;
  @Input() showError = false;
  @Output() onSaveKey = new EventEmitter<{type: string, key: string, appId: string | null}>();

  form: FormGroup;

  constructor(
    private fb: FormBuilder
  ) {
  }

  public get deepSeekApiKey(): FormControl {
    return this.form.get('deepSeekApiKey') as FormControl;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      deepSeekApiKey: [this.apiKeys.deepSeekApiKey, [Validators.required]]
    });
  }

  saveApiKey(): void {
    this.onSaveKey.emit({
      type: 'DEEP_SEEK',
      key: this.deepSeekApiKey.value,
      appId: null
    });
  }
}
